import React, { FC, useCallback } from 'react';
import { Input } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    operatorItem?: any;
    changeInputValue?: any;
    disable?: boolean;
}

const Template: FC<TemplateProps> = React.memo((props) => {
    const { operatorItem, changeInputValue, ...restProps } = props;

    const changeHandle = useCallback(
        (e) => {
            return changeInputValue(operatorItem, 'keyword', e.target.value);
        },
        [changeInputValue, operatorItem]
    );

    return (
        <div
            style={{
                marginLeft: 10,
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
                padding: '10px 0px',
            }}
        >
            <Input.TextArea
                rows={1}
                autoSize
                style={{ width: 400 }}
                maxLength={100}
                value={operatorItem.operatorList?.[0]?.keyword}
                onChange={changeHandle}
                placeholder={
                    /* 请输入大模型提示语 */ UdeskLocales['current'].components
                        .checkPointOperatorListGather.semanticMatching.index
                        .pleaseEnterALargeModelPrompt
                }
                {...restProps}
            />
        </div>
    );
});

export default Template;
